import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("MAIN");

export const updateAdminFlowState = actionCreator<boolean>(
  "UPDATE_ADMIN_FLOW_STATE"
);
